import React from 'react';
import ReactDOM from 'react-dom/client';
import { App, UI, UIState } from './interfaces/Frameworks';
import Login from './components/Login';
import ChangePassword from './components/ChangePassword';
import { Presented } from './components/Presented';
import { DashboardPresenter } from './components/DashboardPresenter';
import { DashboardView } from './components/DashboardView';
import { PublicRouteShell } from './saas/PublicRouteShell';
import { DashboardLoading } from './components/DashboardLoading';

export class DashboardUI {

    private app: App;
    private uiState: UIState = 'loading';
    private root!: ReactDOM.Root;
    private dashboardPresenter!: DashboardPresenter;

    constructor(options: {app: App}) {
        console.log('DashboardUI.constructor()');
        this.app = options.app;
    }

    start() {
        console.log('DashboardUI.start()');

        // home screen presenter
        this.dashboardPresenter = new DashboardPresenter({ app: this.app });

        // initialise the React page
        this.root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
        this.render();
    }

    render() {
        this.root.render(
            <React.StrictMode>
                <PublicRouteShell dashboardContent={this.renderContent()} />
            </React.StrictMode>
        );
    }

    private handlePasswordChanged = () => {
        console.log('DashboardUI: Password changed successfully, redirecting to dashboard');
        this.setState('dashboard');
    }

    private renderContent() {
        switch (this.uiState) {
            case 'loading': {
                return <DashboardLoading />;
            }
            case 'login': {
                return <Login />;
            }
            case 'changePassword': {
                return <ChangePassword onPasswordChanged={this.handlePasswordChanged} />;
            }
            case 'dashboard': {
                return <Presented presenter={this.dashboardPresenter} presentedComponent={DashboardView} />;
            }
            default: {
                return <div>Unknown UI State: {this.uiState}</div>;
            }
        }
    }
    
    setState(state: UIState) {
        console.log('DashboardUI.setState(state: ', state, ')');
        if (this.uiState === state) return;
        this.uiState = state;
        this.render();
    }
}

export function newUI(options: { app: App }): UI {
    return new DashboardUI(options);
}
